import { Box, Checkbox, FormControlLabel } from "@mui/material";
import { OLPaper } from "OLPaper";
import { getBackendErrors, getErrorMessage } from "api/errors";
import { useTranslations } from "api/translations";
import { FormButtons } from "components/FormControls/FormButtons";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { TextInput } from "components/FormControls/TextInput";
import { TopHeader } from "components/Header/TopHeader/TopHeader";
import { LeaveSiteGuard } from "components/Tooltips/LeaveSiteGuard";
import { useNotifications } from "contexts/Toast/ToastProvider";
import { Form, Formik } from "formik";
import { useMessage } from "hooks/intl";
import { useNavigate } from "react-router-dom";
import { backendErrors } from "utilities/backendErrors";
import { focusError } from "utilities/focusError";
import { links } from "utilities/links";
import { useStyles } from "./LanguageForm.styles";

export function AddLanguage() {
  const classes = useStyles();
  const { addLanguage } = useTranslations();
  const { message } = useMessage();
  const navigate = useNavigate();
  const { notify } = useNotifications();

  return (
    <>
      <TopHeader
        title={message({ id: "addLanguage" })}
        clearLink={links.settings}
      />
      <Formik
        enableReinitialize
        initialStatus={{}}
        initialValues={{
          adminDefault: false,
          apiDefault: false,
          code: "",
          name: "",
          order: null,
        }}
        onSubmit={async (values, { setSubmitting, setStatus }) => {
          setSubmitting(true);
          setStatus({});
          try {
            await addLanguage(values);
            navigate(links.settings);
            notify(message({ id: "languageAdded" }));
          } catch (exception) {
            setSubmitting(false);
            notify(getErrorMessage(exception));
            const errors = backendErrors(getBackendErrors(exception));
            setStatus(errors);
            focusError();
          }
        }}
      >
        {({
          handleChange,
          handleSubmit,
          isSubmitting,
          status,
          values,
          dirty,
          initialValues,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              {status?.[""] && (
                <span className={classes.error}>{status[""]}</span>
              )}
              <OLPaper className={classes.OLPaper}>
                <TextInput
                  data-test-id="code"
                  className={classes.SelectInput}
                  label={<RequiredFieldLabel text={message({ id: "code" })} />}
                  name="code"
                />
                <TextInput
                  data-test-id="name"
                  className={classes.SelectInput}
                  label={<RequiredFieldLabel text={message({ id: "name" })} />}
                  name="name"
                />
                <TextInput
                  data-test-id="order"
                  className={classes.SelectInput}
                  label={<RequiredFieldLabel text={message({ id: "order" })} />}
                  name="order"
                  type="number"
                />
                <FormControlLabel
                  className={`${classes.checkbox} ${classes.SelectInput}`}
                  control={
                    <Checkbox
                      color="primary"
                      name="adminDefault"
                      onChange={handleChange}
                      data-test-id="admin-default"
                    />
                  }
                  label={message({ id: "adminDefault" })}
                />
                <FormControlLabel
                  className={`${classes.checkbox} ${classes.SelectInput}`}
                  control={
                    <Checkbox
                      color="primary"
                      name="apiDefault"
                      onChange={handleChange}
                      data-test-id="api-default"
                    />
                  }
                  label={message({ id: "apiDefault" })}
                />
              </OLPaper>
              {!isSubmitting && (
                <LeaveSiteGuard
                  warnBeforeRefresh
                  isDirty={dirty}
                  initialValues={initialValues}
                  currentValues={values}
                />
              )}
              <Box mt={12} />
              <FormButtons
                disableSubmit={isSubmitting}
                onCancelClick={() => navigate(links.settings)}
                onSubmitClick={() => handleSubmit()}
                submitMessage="addLanguage"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
